<div [ngStyle]="{ height: '100%' }" fxLayout="column">
  <div fxFlex="100%" class="u-overflow-auto u-showScrollBar u-padding-24">
    <ng-container [ngSwitch]="viewMode">
      <div *ngSwitchCase="viewModes.edit" class="u-marginBottom-16">
        <form>
          <p
            class="u-marginBottom-8"
            i18n="@@editHubSegmentationItemsDrawer.description"
          >
            Enter items separated by a new line. To bulk add or delete items,
            create your list in your text editor, and paste it into the textbox
            below.
          </p>
          <mat-form-field class="mat-form-field-width-100">
            <textarea
              matInput
              cdkTextareaAutosize
              [cdkAutosizeMinRows]="10"
              [cdkAutosizeMaxRows]="15"
              [formControl]="categoriesInput"
              autocomplete="off"
              required="true"
              class="u-showScrollBar"
              placeholder="Example option 1&#10;Example option 2&#10;Example option 3"
              i18n-placeholder="
                @@editHubSegmentationItemsDrawer.textAreaPlaceholder"
            ></textarea>
          </mat-form-field>
          <mat-error
            *ngIf="categoriesInput.hasError('maxLines')"
            class="text-caption"
            i18n="@@editHubSegmentationItemsDrawer.maxCategoriesError"
          >
            You have reached the limit of {{ categoriesLimit }}
            {{ data.segmentationName }}.
          </mat-error>
        </form>
        <p
          class="color-grey-300 text-caption"
          i18n="@@editHubSegmentationItemsDrawer.duplicateWarning"
        >
          Duplicate items will not be added again.
        </p>
      </div>
      <div *ngSwitchCase="viewModes.summary" class="u-marginBottom-24">
        <p
          class="u-marginBottom-16"
          i18n="@@editHubSegmentationItemsDrawer.itemsSummary"
        >
          Here is a summary of which {{ data.segmentationName }} will be added
          and deleted.
        </p>
        <nz-tabset>
          <nz-tab
            *ngIf="categoriesToAdd.length"
            nzTitle="To add ({{ categoriesToAdd.length }})"
            i18n-nzTitle="@@editHubSegmentationItemsDrawer.toAddTab"
          >
            <nz-table
              #categoriesToAddData
              [nzData]="categoriesToAdd"
              nzSize="small"
              nzBordered
              [nzHideOnSinglePage]="true"
              ><thead>
                <tr>
                  <th>{{ data.segmentationName }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let category of categoriesToAddData.data">
                  <td>{{ category }}</td>
                </tr>
              </tbody>
            </nz-table>
          </nz-tab>
          <nz-tab
            *ngIf="categoriesToDelete.length"
            nzTitle="To delete ({{ categoriesToDelete.length }})"
            i18n-nzTitle="@@editHubSegmentationItemsDrawer.toDeleteTab"
          >
            <nz-table
              #categoriesToDeleteData
              [nzData]="categoriesToDelete"
              nzSize="small"
              nzBordered
              [nzHideOnSinglePage]="true"
              ><thead>
                <tr>
                  <th>{{ data.segmentationName }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let category of categoriesToDeleteData.data">
                  <td>{{ category }}</td>
                </tr>
              </tbody>
            </nz-table>
          </nz-tab>
        </nz-tabset>
      </div>
      <div *ngSwitchCase="viewModes.success" class="u-marginBottom-16">
        <p i18n="@@editHubSegmentationItemsDrawer.resultSummary">
          We've added {{ categoriesToAdd.length }} and deleted
          {{ categoriesToDelete.length }} {{ data.segmentationName }}
        </p>
      </div>
    </ng-container>
  </div>
  <div
    class="u-padding-8-0 u-padding-0-16 u-borderTop-grey100"
    fxFlex="0 0 auto"
    fxLayoutAlign="end center"
    fxLayoutGap="16px"
  >
    <ng-container [ngSwitch]="viewMode">
      <ng-container *ngSwitchCase="viewModes.edit">
        <button
          mat-button
          (click)="closeDrawer()"
          type="button"
          i18n="@@global.cancel"
        >
          Cancel
        </button>
        <button
          mat-raised-button
          color="primary"
          type="button"
          (click)="viewMode = viewModes.summary"
          [disabled]="
            !categoriesInput.valid || isLoading || !areCategoriesUpdated
          "
          i18n="@@editHubSegmentationItemsDrawer.nextCta"
        >
          Next
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="viewModes.summary">
        <button
          mat-button
          type="button"
          (click)="viewMode = viewModes.edit"
          i18n="@@global.back"
        >
          Back
        </button>
        <button
          mat-raised-button
          color="primary"
          (click)="
            saveCategories(
              categoriesInput.value,
              data.group,
              data.segmentationKey
            )
          "
          [disabled]="
            !categoriesInput.valid || isLoading || !areCategoriesUpdated
          "
        >
          <ng-container i18n="@@editHubSegmentationItemsDrawer.saveCta"
            >Save {{ data.segmentationName }}</ng-container
          >
          <i
            *ngIf="isLoading"
            nz-icon
            nzType="sync"
            nzSpin
            class="u-marginLeft-8"
          ></i>
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="viewModes.success">
        <button
          mat-raised-button
          color="primary"
          type="button"
          (click)="closeDrawer()"
          i18n="@@global.gotIt"
        >
          Got it
        </button>
      </ng-container>
    </ng-container>
  </div>
</div>
